import React from "react";

const SmbOffering = () => {
  return (
    <iframe
      src="https://v0-mobile-onboarding-screen-nu.vercel.app/"
      title="SMB Offering"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
};

export default SmbOffering;
